import { getParams } from "../../../../../../../../../src/modules/wizards/services";

export default {
    wizardType: "POSTGRES",

    getJDBCURL: (m) =>
        "jdbc:postgresql://" + m.get("host") + ":" + m.get("port") + "/" + m.get("dbName"),

    getConnectionParams: async (type, model) => getParams(type, model),
};

